import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { AppComponent } from './app.component';
import { OnlineSignPadComponent } from './online-sign-pad/online-sign-pad.component';
import { EDictateComponent } from './e-dictate/e-dictate.component';
import { ApplicationauthComponent } from './e-dictate/applicationauth/applicationauth.component';
import { PictureComponent } from './picture/picture.component';
import { AttachmentComponent } from './attachment/attachment.component';

// Module Route Config for Lazy Loading..

const routes: Routes = [
    { path: '', redirectTo: 'Sign', pathMatch: 'full' },
    { path: 'Sign', component: OnlineSignPadComponent },
    { path: 'Sign/:signId', component: OnlineSignPadComponent },
    { path: 'text', component: EDictateComponent },
    { path: 'text/:signId', component: EDictateComponent },
    { path: 'text/auth', component: ApplicationauthComponent },
    { path: 'text/auth/:signId', component: ApplicationauthComponent },
    { path: 'Picture/auth', component: ApplicationauthComponent },
    { path: 'Picture/auth/:signId', component: ApplicationauthComponent },
    { path: 'Picture', component: PictureComponent },
    { path: 'Picture/:signId', component: PictureComponent },
    { path: 'Attachment', component: AttachmentComponent },
    { path: 'Attachment/:signId', component: AttachmentComponent },
    { path: 'Attachment/auth/:signId', component: ApplicationauthComponent },
    { path: '**', redirectTo: 'Picture' }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: true });
//export const routing: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./SignClient/app/app-routing.module.ts